export const URINARY_NAMES = {
  // Artery matches
  "Kidney_arteries_L": { english: "Left Renal Artery", latin: "Arteria Renalis Sinistra" },
  "Kidney_arteries_R": { english: "Right Renal Artery", latin: "Arteria Renalis Dextra" },
  "Kidney  arteries L": { english: "Left Renal Artery", latin: "Arteria Renalis Sinistra" },
  "Kidney  arteries R": { english: "Right Renal Artery", latin: "Arteria Renalis Dextra" },
  "Kidney arteries L": { english: "Left Renal Artery", latin: "Arteria Renalis Sinistra" },
  "Kidney arteries R": { english: "Right Renal Artery", latin: "Arteria Renalis Dextra" },
  "Artery_L": { english: "Left Renal Artery", latin: "Arteria Renalis Sinistra" },
  "Artery_R": { english: "Right Renal Artery", latin: "Arteria Renalis Dextra" },

  // Vein matches
  "Kidney_Veins_L": { english: "Left Renal Vein", latin: "Vena Renalis Sinistra" },
  "Kidney_Veins_R": { english: "Right Renal Vein", latin: "Vena Renalis Dextra" },
  "Kidney  Veins L": { english: "Left Renal Vein", latin: "Vena Renalis Sinistra" },
  "Kidney  Veins R": { english: "Right Renal Vein", latin: "Vena Renalis Dextra" },
  "Kidney Veins L": { english: "Left Renal Vein", latin: "Vena Renalis Sinistra" },
  "Kidney Veins R": { english: "Right Renal Vein", latin: "Vena Renalis Dextra" },
  "Veins_L": { english: "Left Renal Vein", latin: "Vena Renalis Sinistra" },
  "Veins_R": { english: "Right Renal Vein", latin: "Vena Renalis Dextra" },

  // Bladder matches
  "Bladder": { english: "Urinary Bladder", latin: "Vesica Urinaria" },
  "Bladder_L": { english: "Urinary Bladder (Left)", latin: "Vesica Urinaria (Sinister)" },
  "Bladder_R": { english: "Urinary Bladder (Right)", latin: "Vesica Urinaria (Dexter)" },

  // Sphincter & Urethra
  "External_urethral_sphincter": { english: "External Urethral Sphincter", latin: "Musculus Sphincter Urethrae Externus" },
  "External urethral sphincter": { english: "External Urethral Sphincter", latin: "Musculus Sphincter Urethrae Externus" },
  "Urethra": { english: "Urethra", latin: "Urethra" },

  // Kidney surfaces
  "Kidney_Back_L": { english: "Left Kidney (Posterior Surface)", latin: "Ren Sinister (Facies Posterior)" },
  "Kidney_Back_R": { english: "Right Kidney (Posterior Surface)", latin: "Ren Dexter (Facies Posterior)" },
  "Kidney Back L": { english: "Left Kidney (Posterior Surface)", latin: "Ren Sinister (Facies Posterior)" },
  "Kidney Back R": { english: "Right Kidney (Posterior Surface)", latin: "Ren Dexter (Facies Posterior)" },
  "Kidney_front_L": { english: "Left Kidney (Anterior Surface)", latin: "Ren Sinister (Facies Anterior)" },
  "Kidney_front_R": { english: "Right Kidney (Anterior Surface)", latin: "Ren Dexter (Facies Anterior)" },
  "Kidney front L": { english: "Left Kidney (Anterior Surface)", latin: "Ren Sinister (Facies Anterior)" },
  "Kidney front R": { english: "Right Kidney (Anterior Surface)", latin: "Ren Dexter (Facies Anterior)" },

  // Internal structures
  "Pyramids_L": { english: "Left Renal Pyramids", latin: "Pyramides Renales Sinistrae" },
  "Pyramids_R": { english: "Right Renal Pyramids", latin: "Pyramides Renales Dextrae" },
  "Pyramids L": { english: "Left Renal Pyramids", latin: "Pyramides Renales Sinistrae" },
  "Pyramids R": { english: "Right Renal Pyramids", latin: "Pyramides Renales Dextrae" },

  // Ureters
  "Ureter_L": { english: "Left Ureter (Abdominal Part)", latin: "Ureter Sinister (Pars Abdominalis)" },
  "Ureter_R": { english: "Right Ureter (Abdominal Part)", latin: "Ureter Dexter (Pars Abdominalis)" },
  "Ureter L": { english: "Left Ureter (Abdominal Part)", latin: "Ureter Sinister (Pars Abdominalis)" },
  "Ureter R": { english: "Right Ureter (Abdominal Part)", latin: "Ureter Dexter (Pars Abdominalis)" },
  "Ureter_L_Pelvic": { english: "Left Ureter (Pelvic Part)", latin: "Ureter Sinister (Pars Pelvina)" },
  "Ureter_R_Pelvic": { english: "Right Ureter (Pelvic Part)", latin: "Ureter Dexter (Pars Pelvina)" },
  "Ureter L Pelvic": { english: "Left Ureter (Pelvic Part)", latin: "Ureter Sinister (Pars Pelvina)" },
  "Ureter R Pelvic": { english: "Right Ureter (Pelvic Part)", latin: "Ureter Dexter (Pars Pelvina)" }
};

function normalize(name) {
  if (!name) return '';
  // Convert underscores to spaces, collapse multiple spaces, trim, lowercase
  return name.trim().replace(/[_\s]+/g, ' ').toLowerCase();
}

function stripSuffix(name) {
  // Remove trailing numbers, underscores, and extra spaces
  return name.replace(/\d+$/, '').replace(/[_\s]+$/, '').replace(/\s+/g, ' ').trim();
}

const URINARY_KEYS = Object.keys(URINARY_NAMES);
const NORMALIZED_KEYS = URINARY_KEYS.map(k => normalize(k));
const STRIPPED_KEYS = URINARY_KEYS.map(k => normalize(stripSuffix(k)));

function fuzzyMatch(name) {
  if (!name) return null;
  
  // 1. Try exact match
  if (URINARY_NAMES.hasOwnProperty(name)) return name;

  // 2. Try trimmed match
  const trimmed = name.trim();
  for (const key of URINARY_KEYS) {
    if (key.trim() === trimmed) return key;
  }

  // 3. Try normalized match (no underscores, single spaces, lowercase)
  const norm = normalize(name);
  for (let i = 0; i < NORMALIZED_KEYS.length; i++) {
    if (NORMALIZED_KEYS[i] === norm) return URINARY_KEYS[i];
  }

  // 4. Try stripped match (remove trailing numbers/suffixes)
  const stripped = normalize(stripSuffix(name));
  for (let i = 0; i < STRIPPED_KEYS.length; i++) {
    if (STRIPPED_KEYS[i] === stripped) return URINARY_KEYS[i];
  }

  // 5. Try partial keyword matches as a last resort
  if (norm.includes('kidney') && norm.includes('arter')) {
    if (norm.includes('left') || norm.endsWith(' l')) return 'Kidney_arteries_L';
    if (norm.includes('right') || norm.endsWith(' r')) return 'Kidney_arteries_R';
  }
  if (norm.includes('kidney') && norm.includes('vein')) {
    if (norm.includes('left') || norm.endsWith(' l')) return 'Kidney_Veins_L';
    if (norm.includes('right') || norm.endsWith(' r')) return 'Kidney_Veins_R';
  }
  if (norm.includes('bladder')) return 'Bladder';
  if (norm.includes('ureter')) {
    if (norm.includes('pelvic')) {
      if (norm.includes('left') || norm.endsWith(' l')) return 'Ureter_L_Pelvic';
      if (norm.includes('right') || norm.endsWith(' r')) return 'Ureter_R_Pelvic';
    }
    if (norm.includes('left') || norm.endsWith(' l')) return 'Ureter_L';
    if (norm.includes('right') || norm.endsWith(' r')) return 'Ureter_R';
  }

  return null;
}

export function resolveUrinaryName(mesh) {
  if (!mesh) return null;

  const meshName = mesh.name || '';
  const matName = mesh.material?.name || '';
  const parentName = mesh.parent?.name || '';

  if (meshName) { const match = fuzzyMatch(meshName); if (match) return match; }
  if (matName) { const match = fuzzyMatch(matName); if (match) return match; }
  if (parentName) { const match = fuzzyMatch(parentName); if (match) return match; }

  let ancestor = mesh.parent;
  while (ancestor) {
    if (ancestor.name) { const match = fuzzyMatch(ancestor.name); if (match) return match; }
    ancestor = ancestor.parent;
  }

  if (meshName.length > 0) return meshName;
  if (matName.length > 0) return matName;

  return null;
}

export function getUrinaryInfo(meshName) {
  if (!meshName) return { english: "Unknown Structure", latin: "Incertum" };

  const matched = fuzzyMatch(meshName);
  if (matched && URINARY_NAMES[matched]) return URINARY_NAMES[matched];

  let clean = meshName.replace(/_/g, ' ').replace(/\d+$/, '').replace(/\s+/g, ' ').trim();
  clean = clean.replace(/\bL\b/g, 'Left').replace(/\bR\b/g, 'Right');

  const LATIN_MAP = {
    "kidney": "Ren", "arteries": "Arteriae", "veins": "Venae",
    "bladder": "Vesica Urinaria", "ureter": "Ureter", "urethra": "Urethra",
    "pyramids": "Pyramides Renales", "left": "Sinister", "right": "Dexter",
    "external urethral sphincter": "Musculus Sphincter Urethrae Externus",
    "posterior": "Facies Posterior", "anterior": "Facies Anterior",
    "back": "Facies Posterior", "front": "Facies Anterior",
    "abdominal": "Pars Abdominalis", "pelvic": "Pars Pelvina"
  };

  let latinClean = clean.toLowerCase();
  for (const [eng, lat] of Object.entries(LATIN_MAP)) {
    latinClean = latinClean.replace(eng, lat);
  }
  if (latinClean === clean.toLowerCase()) latinClean = clean;

  return { english: clean, latin: latinClean };
}
